import EncryptionUtil from "./encryptionUtil";
import { groupBy3 } from "./objectUtils";

// User preferences share the "form_" prefix with cached form content, so they have to
// be spared here — clearing the cache on login used to reset the user's own settings.
const PRESERVED_KEYS = new Set(["form_autosave", "form_autosave_prompt", "form_theme"]);

export function removeAllCachedForms() {
    const keysToRemove = [];

    // Collect all keys that start with "form_"
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("form_") && !PRESERVED_KEYS.has(key)) {
            keysToRemove.push(key);
        }
    }

    // Remove the collected keys
    for (const key of keysToRemove) {
        localStorage.removeItem(key);
    }
}

export async function cacheFormsContent(forms) {
    for (const form of forms) {
        try {
            const response = await fetch(form.UrlToApi);
            const content = await response.text(); // Get raw text

            const values = JSON.parse(content); // Parse to object/array
            const data = groupBy3(values, "object"); // Group by "object" key

            const encrypted = EncryptionUtil.obfuscate(data)
            localStorage.setItem(`form_${form.ID}`, encrypted); // Store as string
        } catch (err) {
            console.warn(`Failed to fetch form ${form.ID}:`, err);
        }
    }
}